import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'shared/store/store'

type StoreUpdateObject = {
  year: string
  pageSize: number
  page: number
  searchString: string
  sortState: SortingState
}

export interface ColumnSort {
  desc: boolean
  id: string
}
export type SortingState = ColumnSort[]

const initialState = {
  year: new Date().getFullYear().toString(),
  pageSize: 50,
  page: 0,
  searchString: '',
  sortState: [] as SortingState,
}

const reimbursementSlice = createSlice({
  name: 'reimbursement',
  initialState,
  reducers: {
    setYear: (state, action: PayloadAction<string>) => {
      state.year = action.payload
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload
    },
    setSearchString: (state, action: PayloadAction<string>) => {
      state.searchString = action.payload
    },
    setSortState: (state, action: PayloadAction<SortingState>) => {
      state.sortState = action.payload
    },
    setStoreUpdateObject: (state, action: PayloadAction<StoreUpdateObject>) => {
      state.year = action.payload.year
      state.pageSize = action.payload.pageSize
      state.page = action.payload.page
      state.searchString = action.payload.searchString
      state.sortState = action.payload.sortState
    },
  },
})

export const {
  setYear,
  setPageSize,
  setPage,
  setSearchString,
  setStoreUpdateObject,
  setSortState,
} = reimbursementSlice.actions

export default reimbursementSlice

export const getYear = (state: RootState) => state.reimbursement.year

export const getPageSize = (state: RootState) => state.reimbursement.pageSize

export const getPage = (state: RootState) => state.reimbursement.page

export const getSearchString = (state: RootState) =>
  state.reimbursement.searchString

export const getStoreUpdateObject = (state: RootState) => state.reimbursement

export const getSortState = (state: RootState) => state.reimbursement.sortState
